import React from 'react';
import s from './Arrow.scss';
import classNames from 'classnames';
export const Arrow = ({ left = false }) => {
    return React.createElement("span", { className: classNames(s.icon, { [s.left]: left }) });
};
//# sourceMappingURL=Arrow.js.map